<template>
	<c-modal @close="close" :title="title">

		<c-form ref="form" @valid="submit" class="margin-t-40" v-if="!success">

            <p>Selecteer de velden die je wilt exporteren</p>

                <c-checkbox v-if="headings.length > 0"
					id="stock"
					v-model="heading"
					:horizontal="true"
					:labeltext="'text'"
					:options="headings"
					:ValueName="'value'"
                    :valueText="'text'"
                    :twoColumns="true">
				</c-checkbox>

            <div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Exporteren</c-button>
				</div>
			</div>

		</c-form>
        <div v-else>
            <p>Export mail verstuurd</p>
        </div>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import Loader from '@components/loader/Container';

export default {
	mixins: [Form],
	components: {
		CModal, Loader
	},
    props: {
        exportType: {
            required: false,
            type: String
        },
        title: {
            required: false,
            type: String
        },
        search: {
            required: false,
            type: String
        },
        sort: {
            required: false,
            type: String
        },
        direction: {
            required: false,
            type: String
        }
    },
	data() {
		return {
            heading: [],
			errors: {},
			loading: false,
            headings: [],
            success: false
		};
	},
    methods: {
        close() {
            this.$emit('close');
        },
        submit(){
            this.$xhr.get('/api/exportstockcsv?search=' + this.search + '&sort=' + this.sort + '&order=' + this.direction + '&headings=' + this.heading).then(({result}) => {
                this.$store.dispatch('toast/success', {title: 'Export', text: 'Export wordt verstuurd naar uw e-mailadres'});
                this.close();
            }).catch((e) => {});
        }
    },
	mounted() {
        this.$xhr.get('/api/export-columns').then(({result}) => {
            this.headings = result.map(heading => ({ text: heading, value: heading }));
            this.heading = this.headings.map(heading => heading.value);
        }).catch((e) => {});
	}
}
</script>
